<template>
  <div class="item-box">
    <table>
      <thead>
        <tr>
          <td width="180">物料名称</td>
          <td width="60">品项</td>
          <td width="60">品牌</td>
          <td width="100">机型</td>
          <td width="60">模块</td>
          <td width="80">租赁单价</td>
          <td width="80">数量</td>
          <td width="140">租赁周期</td>
          <td width="120">保修</td>
          <td width="80">租金费用</td>
          <td width="80">押金额度</td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{product.ProductName}}<br> 物料编码：{{product.ProductCode}}</td>
          <td>
            <el-tag :type="product.ConditionName | ConditionColor">{{product.ConditionName}}</el-tag>
          </td>
          <td>{{product.ProductBrandName}}</td>
          <td>{{product.ProductModelName}}</td>
          <td>{{product.ProductModuleName}}</td>
          <td>{{product.RentalUnitPrice | amount}}</td>
          <td>
            <el-input-number placeholder="数量" :min="1" :max="deliveryType === 'immediateDelivery' ? product.Quantity : Infinity" v-model="product.RentalQuantity" style="width: 130px"></el-input-number>
          </td>
          <td>
            <el-select placeholder="租赁周期" v-model="product.RentalPeriod" @change="handleRentalPeriodChange">
              <el-option v-for="item in rentalPeriods"
              :key="item.PeriodInMonths"
              :label="item.PeriodInMonths + '个月'"
              :value="item.PeriodInMonths"
              :disabled = "orderType === 'flexibleTerm' ? item.PeriodInMonths !== 3:false"
              >
              <!-- 当订单类型为灵活租期时，禁用3个月以外的租赁时长 -->
              </el-option>
            </el-select>
          </td>
          <td>
            <el-select v-model="product.WarrantyMonths" placeholder="保修周期">
              <el-option label="无保修" :value="0"></el-option>
              <el-option label="3个月" :value="3"></el-option>
              <el-option label="6个月" :value="6"></el-option>
              <el-option label="9个月" :value="9"></el-option>
              <el-option label="12个月" :value="12"></el-option>
            </el-select>
          </td>
          <td>{{product.SubTotalRentalAmount | amount}}</td>
          <td>{{product.Deposit | amount}}</td>
        </tr>
      </tbody>
    </table>
    <el-button class="delete-btn" @click="() => this.$emit('delete', index)">X</el-button>
  </div>
</template>

<script>
import o from '@/odata'
export default {
  props: {
    product: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    orderType: String,
    deliveryType: String,
  },
  data() {
    return {
      rentalPeriods: [],
    }
  },
  // 监听值改变事件
  watch: {
    // 批次数量发生改变
    'product.RentalQuantity'(value) {
      this.handleCompute()
      this.handleComputeDeposit()
      // 计算租金费用
      this.product.SubTotalRentalAmount = this.product.RentalUnitPrice * this.product.RentalQuantity
    },
    // 租赁周期发生改变
    'product.RentalPeriod'(value) {
      this.handleCompute()
    },
    // 保修时长发生改变
    'product.WarrantyMonths'(value) {
      this.handleCompute()
    },
    'deliveryType'(value) {
      if (value === 'immediateDelivery' && this.product.RentalQuantity > this.product.Quantity) {
        this.product.RentalQuantity = this.product.Quantity
      }
    },
  },
  methods: {
    // 加载租赁单价
    initRentPrice() {
      const response = o('ProductRentalPricelist')
      // 根据当前批次，品相，进行计算(非原装全新匹配原装二手)
      response.filter(`ProductId eq ${this.product.ProductId}
        and ConditionId eq ${this.product.ProductConditionId === 1 ? this.product.ProductConditionId : 4}
        and IsDeleted eq false
        and IsRepairPrice eq false
        `)
      response.orderBy('PeriodInMonths', 'asc')
      // 获取到价格赋值给批次对象
      response.get().then((data) => {
        // 遍历所有租赁周期的租赁价格
        data.data.forEach((item) => {
          // TODO 根据数据库存在的租赁周期来生成租赁周期下拉框
          // 获取当前选中租赁周期的价格
          if (item.PeriodInMonths === this.product.RentalPeriod) {
            this.product.RentalUnitPrice = item.RentalPrice
          }
          this.rentalPeriods.push({
            PeriodInMonths: item.PeriodInMonths,
            RentalPrice: item.RentalPrice,
          })
        })
        this.product.SubTotalRentalAmount = this.product.RentalUnitPrice * this.product.RentalQuantity
      })
      // 计算租赁费用
      // this.$set(this, 'leaseapplybox', this.leaseapplybox)
    },
    // 计算租赁总价格
    handleCompute() {
      const { RentalQuantity, RentalPeriod, WarrantyMonths } = this.product
      if (RentalQuantity <= 0 || !RentalPeriod || (!WarrantyMonths && WarrantyMonths !== 0)) return
      const form = {
        PartnerId: 2,
        OrderType: this.OrderType,
        Lines: [{
          ProductId: this.product.ProductId,
          ProductConditionId: this.product.ConditionId,
          RentalQuantity: this.product.RentalQuantity,
          RentalPeriod: this.product.RentalPeriod,
          WarrantyMonths: this.product.WarrantyMonths,
          DiscountRate: 1,
        }],
      }
      o('RentalOrder/Services.Compute').post(form).save().then(({ data }) => {
        console.log('data', data)
        // Object.assign(Product, data.Lines[0])
        for (var property in data.Lines[0]) {
          if (data.Lines[0].hasOwnProperty(property)) {
            var value = data.Lines[0][property]
            this.$set(this.product, property, value)
          }
        }
      }).catch((error) => {
        this.$alert(error.message)
      })
    },
    // 计算总押金价格
    handleComputeDeposit() {
      const ProductId = this.product.ProductId
      const Quantity = this.product.RentalQuantity
      o(`RentalOrder/Services.ComputeDeposit(productId=${ProductId},quantity=${Quantity})`).get().then(({ data }) => {
        console.log('data', data)
        if (data && data.DepositAmount) {
          this.product.Deposit = data.DepositAmount
        }
      }).catch(({error}) => {
        this.$alert(error.message)
      })
    },
    handleRentalPeriodChange(selectValue) {
      // 计算租金费用
      this.product.RentalUnitPrice = this.rentalPeriods.find(item => item.PeriodInMonths === selectValue).RentalPrice
      this.product.SubTotalRentalAmount = this.product.RentalUnitPrice * this.product.RentalQuantity
    },
  },
}
</script>

<style lang="less" scoped>
table tbody td {
  padding-right: 5px;
}

.form-input {
  width: 260px;
}

.list-layout .complex-table .sub-row-table .sub-body .text-center {
  border-right: 1px solid #dfe6ec;
  border-bottom: 1px solid #dfe6ec;
}

.main-content {
  .tab {
    .el-tabs__active-bar {
      background-color: rgba(0, 0, 0, 0);
    }
  }
}

.add-btn:hover,
.add-btn:focus {
  color: #FFFFFF;
  background: #2283CA;
}

.item-box {
  position: relative;
  padding: 20px;
  background-color: #fff;
  margin-bottom: 25px;
  border: 1px solid #E1E8EE;
  width: 97%;
  .el-select,
  .el-input {
    width: 100%;
  }
  .delete-btn {
    position: absolute;
    right: -40px;
    top: 40%;
    background-color: #FF4949;
    color: #fff;
    padding: 10px 12px;
    border-radius: 50%;
    border: none;
  }
  table {
    display: inline-block;
    label {
      display: block;
      margin-bottom: 5px;
    }
    td {
      padding-right: 20px;
    }
    td:last-child {
      padding-right: 0;
    }
  }
}

.sumbit_box {
  p {
    text-align: right;
    font-size: 18px;
    color: #1F2D3D;
    span {
      color: #FF4949;
    }
  }
  .el-button {
    margin-left: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// LeaseApplyForm.vue?63204d02